/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player";

function Youtube({ url, divStyle, width, height, playerStyle = {},autoplay }) {
  return (
    <Box sx={divStyle}>
      <ReactPlayer
        url={url}
        controls
        width={width}
        height={height}
        style={playerStyle}
        playing={autoplay}
      />
    </Box>
  );
}

export default Youtube;
